import { Link, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

export const Buttons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '8px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}))

export const HelperBox = styled('div')(({ theme }) => ({
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  marginTop: '28px',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    height: '1px',
    width: 'calc(50% - 122px / 2 - 24px)', // 122px - HelperText width
    backgroundColor: theme.colors.grey[300],
  },
  '&::before': {
    left: 0,
  },
  '&::after': {
    right: 0,
  },
}))

export const HelperLink = styled(Link)(({ theme }) => ({
  color: theme.colors.grey[900],
  textDecoration: 'underline',
  fontWeight: '600',
}))

export const HelperText = styled(Typography)(({ theme }) => ({
  color: theme.colors.grey[900],
  textTransform: 'uppercase',
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: 1.4,
}))

export const TermsBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '5px',
})

export const TermsText = styled(Typography)(({ theme }) => ({
  color: theme.colors.grey[700],
  textAlign: 'center',
  fontSize: '0.5625rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '0.625rem',
  },
}))
